export const ABOUTUS = 'aboutus'
export const PUBLICATIONS = 'publication'
export const ACTIVITIES = 'activities'
export const CITIZEN_CORNER = 'citizen'
export const IRS_CORNER = 'irscorner'
export const RESOURCES = 'resources'
